export default "__VITE_ASSET__87f29dfe__"